import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Color, Size } from 'const'
import _ from 'lodash'

function PageTitle({ title, text, textStyles = { color: Color.FONT.MENU_DARK }, titleStyles = {}, isTop }) {
  const newTextStyles = _.merge(textStyles, { whiteSpace: 'pre-line' })
  const textElement = text && <TextBlock style={newTextStyles}>{text}</TextBlock>
  const titleElement = title && (
    <TitleBlock isTop={isTop} style={titleStyles}>
      {title}
    </TitleBlock>
  )

  return (
    <Wrapper>
      {titleElement}
      {textElement}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const TitleBlock = styled.div`
  font-size: ${Size.FONT.HEADLINE.XL};
  display: flex;
  align-items: center;
  padding: 0 20px 10px;
  flex: 0 0 66px;
  font-weight: 700;
`

const TextBlock = styled.div`
  font-size: ${Size.FONT.HEADLINE.MEDIUM};
  padding: 0 20px 30px;
  font-weight: 700;
`

PageTitle.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  textStyles: PropTypes.instanceOf(styled.style),
}

export default PageTitle
